export const types = {
    subir : '[Order] subir',
    cargar : '[Order] cargar',
    eliminar : '[Order] eliminar',
    eliminacionexito : '[Order] eliminacionexito',
    solicitudes : '[Order] solicitudes',
    solicitud : '[Order] solicitud',
    solicitudrechazada : '[Order] solicitudrechazada',
    categoriaseleccionada: '[Order] categoriaseleccionada'
  }